export const environment = {
  production: false,
  tokenizerUrl: 'a://a.a', // placeholder for URL
  env: 'local',
  tokenizerRouteId: '',
  activities: {
    freeCancellationId: null,
    specialFilters: [],
  },
};
